import { Component, ElementRef, ViewChild, AfterViewInit, OnDestroy, OnInit, Renderer2, Inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { SuiteTechnologiesComponent } from '../../../general/suite-technologies/suite-technologies.component';
import { FaqComponent } from '../../../shared/faq/faq.component';
import { FaqItem } from '../../../models/faq.model';
import { ExploreMoreServicesComponent } from '../explore-more-services/explore-more-services.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContactUsComponent } from '../../../shared/contact-us/contact-us.component';

interface TimelineCard {
  id: number;
  year: string;
  title: string;
  description: string;
  image: string;
}
@Component({
  selector: 'app-it-consulting',
  imports: [CommonModule, FaqComponent, ExploreMoreServicesComponent],
  standalone: true,
  templateUrl: './it-consulting.component.html',
  styleUrl: './it-consulting.component.scss'
})
export class ItConsultingComponent implements AfterViewInit, OnDestroy {
  @ViewChild('featuresSection') featuresSection!: ElementRef;
  @ViewChild('whyChooseSection') whyChooseSection!: ElementRef;
  @ViewChild('heroVideo') heroVideo!: ElementRef<HTMLVideoElement>;
  isFeaturesVisible = false;
  isWhyChooseVisible = false;
  private jsonLdScript: any;
  private observer: IntersectionObserver | null = null;

  constructor(
    @Inject(DOCUMENT) private _document: Document,
    private _renderer: Renderer2,
    private modalService: NgbModal
  ) { }

  goToCaseStudies(): void {

  }
  ngOnInit(): void {
    this.injectSchemaMarkup();
  }
  private forcePlayHeroVideo() {
    const video = this.heroVideo?.nativeElement;
    if (!video) return;

    video.muted = true;           // required for autoplay
    video.playsInline = true;

    const play = () => {
      video.play().catch(() => {
        // retry if browser blocks
        setTimeout(() => video.play().catch(() => { }), 300);
      });
    };

    // Ensure it runs after Angular rendering
    setTimeout(play, 100);
  }
  itConsultingFaqs: FaqItem[] = [
    {
      question: 'What is IT Consulting?',
      answer: `IT consulting involves providing expert advice on how to leverage technology to 
      improve business operations, reduce costs, and enhance efficiency.`
    },
    {
      question: 'Why should I hire an IT Consultant company?',
      answer: `Hiring an IT consultant company/IT service provider helps you avoid costly mistakes, 
      stay competitive, and ensure your technology infrastructure supports your business goals.`
    },
    {
      question: 'What industries do you serve?',
      answer: `We serve a wide range of industries, including Fintech, Healthcare, E-commerce, 
      Insurtech, and Hi-tech.`
    },
    {
      question: 'How much does IT consulting cost?',
      answer: `Our pricing depends on the scope of the project. We offer affordable packages 
      tailored to your specific needs.`
    },
    {
      question: 'What makes Kalpita Technologies different from other IT consulting firms?',
      answer: `Our personalized approach, industry expertise, and commitment 
      to delivering results set us apart.`
    }
  ];

  @ViewChild('benefitCardsContainer', { static: false }) private benefitCardsContainer!: ElementRef;

  timelinecards: TimelineCard[] = [
    {
      id: 1,
      year: '2020',
      title: 'AI-Powered Recruitment Transformation for Smarter Hiring',
      description: `Kalpita Technologies replaced manual, Excel-based hiring with an AI-driven recruitment system. The solution automated workflows, centralized candidate data, and delivered real-time analytics through Azure-based AI tools. With RAG chatbot integration, recruiters gained instant insights, faster decisions, and a smarter, data-driven hiring experience.`,
      image: 'https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?w=400&h=300&fit=crop'
    }
    //  {
    //    id: 2,
    //    year: '2023',
    //    title: 'Modernizing US Retirement Plan Analytics ',
    //    description: 'Our team developed a scalable analytics system for a US-based financial firm, automating intricate reporting processes and reducing manual workloads. With this solution, advisors gained actionable insights and delivered timely, error-free client reporting.',
    //    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=300&fit=crop'
    //  },
    //  {
    //    id: 3,
    //    year: '2025',
    //    title: 'AI-Powered Insurance Application',
    //    description: 'Harnessing the latest in AI and cloud, Kalpita engineered an insurance application that automates claims processing and fraud detection. The application slashed processing times, improved accuracy, and delivered outstanding customer experiences.',
    //    image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=400&h=300&fit=crop'
    //  }
    // {
    //   id: 4,
    //   year: '2026',
    //   title: 'Future Vision',
    //   description: 'Leading the way in digital transformation and AI-powered solutions.',
    //   image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=300&fit=crop'
    // },
    // {
    //   id: 5,
    //   year: '2027',
    //   title: 'Global Reach',
    //   description: 'Expanding our presence globally with cutting-edge technology solutions.',
    //   image: 'https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?w=400&h=300&fit=crop'
    // }
  ];

  selectedIndex = 0;

  get visibleCards(): Array<{ card: TimelineCard, position: 'top' | 'center' | 'bottom' }> {
    const result = [];
    const totalCards = this.timelinecards.length;

    if (totalCards === 0) return [];

    // Case 1: Single Card
    if (totalCards === 1) {
      result.push({
        card: this.timelinecards[0],
        position: 'center' as const
      });
      return result;
    }

    // Case 2: Multiple Cards (Standard Logic)
    // Top card (only if exists and not the first one)
    if (this.selectedIndex > 0) {
      result.push({
        card: this.timelinecards[this.selectedIndex - 1],
        position: 'top' as const
      });
    }

    // Center card
    result.push({
      card: this.timelinecards[this.selectedIndex],
      position: 'center' as const
    });

    // Bottom card (only if exists and not the last one)
    if (this.selectedIndex < totalCards - 1) {
      result.push({
        card: this.timelinecards[this.selectedIndex + 1],
        position: 'bottom' as const
      });
    }

    return result;
  }

  get showCarouselDots(): boolean {
    return this.timelinecards.length > 3;
  }

  selectCard(position: 'top' | 'center' | 'bottom'): void {
    if (this.timelinecards.length <= 1) return; // Do nothing if single card

    if (position === 'top' && this.selectedIndex > 0) {
      this.selectedIndex--;
    } else if (position === 'bottom' && this.selectedIndex < this.timelinecards.length - 1) {
      this.selectedIndex++;
    }
  }

  goToCard(index: number): void {
    if (index >= 0 && index < this.timelinecards.length) {
      this.selectedIndex = index;
    }
  }

  get canScrollUp(): boolean {
    return this.selectedIndex > 0;
  }

  get canScrollDown(): boolean {
    return this.selectedIndex < this.timelinecards.length - 1;
  }

  whyChooseFeatures = [
    {
      icon: '../../../../assets/services/it-consulting/whyChooseUs/ExpertiseAcrossCloudSecurityInfrastructure.png',
      title: 'Expertise Across Cloud, Security & Infrastructure',
      description: 'Our specialists bring deep experience in Azure, AWS, cybersecurity, DevOps, and enterprise architecture.'
    },
    {
      icon: '../../../../assets/services/it-consulting/whyChooseUs/End-to-EndITSolutions.png',
      title: 'End-to-End IT Solutions',
      description: 'From strategy consulting to implementation and ongoing support, we provide full-cycle IT consulting to ensure long-term success.'
    },
    {
      icon: '../../../../assets/services/it-consulting/whyChooseUs/TailoredtoYourBusiness.png',
      title: 'Tailored to Your Business',
      description: 'We understand that each business is unique, and our IT solutions are customized to meet your specific needs, goals, and budget.'
    },
    {
      icon: '../../../../assets/services/it-consulting/whyChooseUs/ReliableSupport.png',
      title: 'Reliable Support',
      description: 'Kalpita Technologies offers strong IT support and managed IT services to keep your systems running smoothly without interruption.'
    }
  ];

  developmentProcess = [
    {
      icon: '../../../../assets/services/it-consulting/developmentProcess/InitialConsultation.png',
      title: 'Initial Consultation',
      description: 'Schedule a free consultation to understand your business requirements.'
    },
    {
      icon: '../../../../assets/services/it-consulting/developmentProcess/CustomITStrategyDevelopment.png',
      title: 'Custom IT Strategy Development',
      description: 'We analyze your current systems and create a tailored IT strategy.'
    },
    {
      icon: '../../../../assets/services/it-consulting/developmentProcess/ImplementationIntegration.png',
      title: 'Implementation & Integration',
      description: 'Our team helps implement and integrate the right technologies for your business.'
    },
    {
      icon: '../../../../assets/services/it-consulting/developmentProcess/OngoingSupportOptimization.png',
      title: 'Ongoing Support & Optimization',
      description: 'Benefit from continuous monitoring and optimization of your IT infrastructure.'
    },
    // {
    //   icon: '../../../../assets/home/services/software-dev.webp',
    //   title: 'Continuous Optimization',
    //   description: 'Monitor and refine models with performance analytics and real-time feedback loops.'
    // }
  ];

  // Service Overview section data and logic
  services = [
    {
      title: 'Faster Time to Market',
      description: 'We design software that grows with your business and adapts to new technologies.',
      icon: 'https://i.ibb.co/yBNtD9z/future-ready.png'
    },
    {
      title: 'Secure & Compliant',
      description: 'Our agile development process ensures quick and efficient delivery of your software.',
      icon: 'https://i.ibb.co/yBNtD9z/future-ready.png'
    },
    {
      title: 'Innovation at Core',
      description: 'We build robust and secure software that complies with industry standards.',
      icon: 'https://i.ibb.co/yBNtD9z/future-ready.png'
    },
    {
      title: 'Future-Ready Architecture',
      description: 'We leverage the latest technologies to build innovative and cutting-edge software.',
      icon: 'https://i.ibb.co/yBNtD9z/future-ready.png'
    },
    {
      title: 'End to End Support',
      description: 'We provide comprehensive support and maintenance services for your software.',
      icon: 'https://i.ibb.co/yBNtD9z/future-ready.png'
    }
  ];
  selectedServiceIndex = 3; // Default to "Future-Ready Architecture"

  // Pre-defined positions for the icons on the arc and the active position
  private arcPositions = [
    { x: -180, y: 80 },
    { x: -110, y: -20 },
    { x: 0, y: -60 },
    { x: 110, y: -20 },
    { x: 180, y: 80 }
  ];
  private activePosition = { x: 0, y: 150 };

  selectService(index: number): void {
    this.selectedServiceIndex = index;
  }

  getPointTransform(index: number): string {
    let pos;
    if (index === this.selectedServiceIndex) {
      pos = this.activePosition;
    } else {
      pos = this.arcPositions[index];
    }
    return `translate(${pos.x}px, ${pos.y}px)`;
  }

  readMore(): void {
  }
  ngOnDestroy(): void {
    this.removeSchemaMarkup();
    if (this.observer) {
      this.observer.disconnect();
    }
  }
  injectSchemaMarkup(): void {
    const itConsultingSchema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://www.kalpitatechnologies.com/company-services/it-consulting#webpage",
          "url": "https://www.kalpitatechnologies.com/company-services/it-consulting",
          "name": "IT Consulting Services | Cloud, Security & Infrastructure | Kalpita Technologies",
          "description": "Expert IT consulting services for cloud solutions, cybersecurity, IT infrastructure, and digital transformation.",
          "isPartOf": { "@id": "https://www.kalpitatechnologies.com/#website" },
          "inLanguage": "en-US"
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.kalpitatechnologies.com/company-services/it-consulting#breadcrumbs",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.kalpitatechnologies.com/" },
            { "@type": "ListItem", "position": 2, "name": "Services", "item": "https://www.kalpitatechnologies.com/company-services" },
            { "@type": "ListItem", "position": 3, "name": "IT Consulting", "item": "https://www.kalpitatechnologies.com/company-services/it-consulting" }
          ]
        },
        {
          "@type": "Service",
          "@id": "https://www.kalpitatechnologies.com/company-services/it-consulting#service",
          "name": "IT Consulting Services",
          "serviceType": "IT Consulting",
          "provider": { "@id": "https://www.kalpitatechnologies.com/#organization" },
          "description": "Comprehensive IT consulting services empowering businesses to optimize technology infrastructure, including cloud, security, and digital transformation."
        },
        {
          "@type": "HowTo",
          "@id": "https://www.kalpitatechnologies.com/company-services/it-consulting#process",
          "name": "Kalpita's IT Consulting Process",
          "step": [
            { "@type": "HowToStep", "position": 1, "name": "Initial Consultation", "text": "Schedule a free consultation to understand business requirements." },
            { "@type": "HowToStep", "position": 2, "name": "Strategy Development", "text": "Analyze systems and create a tailored IT strategy." },
            { "@type": "HowToStep", "position": 3, "name": "Implementation", "text": "Implement and integrate the right technologies for your business." },
            { "@type": "HowToStep", "position": 4, "name": "Ongoing Support", "text": "Continuous monitoring and optimization of your IT infrastructure." }
          ]
        },
        {
          "@type": "FAQPage",
          "@id": "https://www.kalpitatechnologies.com/company-services/it-consulting#faq",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What is IT Consulting?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "IT consulting involves providing expert advice on how to leverage technology to improve business operations, reduce costs, and enhance efficiency."
              }
            }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://www.kalpitatechnologies.com/#organization",
          "name": "Kalpita Technologies",
          "url": "https://www.kalpitatechnologies.com/",
          "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
        }
      ]
    };

    this.jsonLdScript = this._renderer.createElement('script');
    this.jsonLdScript.type = 'application/ld+json';
    this.jsonLdScript.text = JSON.stringify(itConsultingSchema);
    this._renderer.appendChild(this._document.head, this.jsonLdScript);
  }

  removeSchemaMarkup(): void {
    if (this.jsonLdScript) {
      this._renderer.removeChild(this._document.head, this.jsonLdScript);
      this.jsonLdScript = null;
    }
  }
  setupTiltEffect(): void {
    const cards = document.querySelectorAll('.feature-card, .features-img');

    cards.forEach(card => {
      const cardEl = card as HTMLElement;

      const mouseMoveHandler = (e: MouseEvent) => {
        const rect = cardEl.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const xc = rect.width / 2;
        const yc = rect.height / 2;

        const maxRotate = 10;

        const rotateY = ((x - xc) / xc) * maxRotate;
        const rotateX = ((yc - y) / yc) * maxRotate;

        cardEl.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.02, 1.02, 1.02)`;
      };

      const mouseLeaveHandler = () => {
        cardEl.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)';
      };

      const mouseEnterHandler = () => {
        cardEl.style.transition = 'transform 0.1s ease-out, box-shadow 0.2s ease-in-out, background 0.2s ease';
      };

      cardEl.addEventListener('mousemove', mouseMoveHandler as EventListener);
      cardEl.addEventListener('mouseleave', mouseLeaveHandler as EventListener);
      cardEl.addEventListener('mouseenter', mouseEnterHandler as EventListener);

      if (window.matchMedia('(hover: none) and (pointer: coarse)').matches) {
        cardEl.removeEventListener('mousemove', mouseMoveHandler as EventListener);
        cardEl.style.transform = 'none';
      }
    });
  }

  setupScrollAnimation(): void {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {

          if (this.featuresSection && entry.target === this.featuresSection.nativeElement) {
            this.isFeaturesVisible = true;
            observer.unobserve(entry.target);
          }

          if (this.whyChooseSection && entry.target === this.whyChooseSection.nativeElement) {
            this.isWhyChooseVisible = true;
            observer.unobserve(entry.target);
          }
        }
      });
    }, {
      threshold: 0.2
    });

    if (this.featuresSection) {
      observer.observe(this.featuresSection.nativeElement);
    }

    if (this.whyChooseSection) {
      observer.observe(this.whyChooseSection.nativeElement);
    }

    this.observer = observer;
  }
  ngAfterViewInit(): void {
    this.forcePlayHeroVideo();
    this.setupTiltEffect();
    this.setupScrollAnimation();
    const cards = document.querySelectorAll('.feature-card, .features-img');

    cards.forEach(card => {
      const cardEl = card as HTMLElement;

      const mouseMoveHandler = (e: MouseEvent) => {
        const rect = cardEl.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        // Calculate center
        const xc = rect.width / 2;
        const yc = rect.height / 2;

        // Max rotation degrees
        const maxRotate = 10;

        // Calculate rotation based on cursor position
        const rotateY = ((x - xc) / xc) * maxRotate;
        const rotateX = ((yc - y) / yc) * maxRotate; // Inverse Y axis

        // Apply transform
        cardEl.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.02, 1.02, 1.02)`;
      };

      const mouseLeaveHandler = () => {
        // Reset to flat state
        cardEl.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)';
      };

      const mouseEnterHandler = () => {
        // Smooth entry
        cardEl.style.transition = 'transform 0.1s ease-out, box-shadow 0.2s ease-in-out, background 0.2s ease';
      };

      // Attach Listeners
      cardEl.addEventListener('mousemove', mouseMoveHandler as EventListener);
      cardEl.addEventListener('mouseleave', mouseLeaveHandler as EventListener);
      cardEl.addEventListener('mouseenter', mouseEnterHandler as EventListener);

      // Optional: Disable on touch devices for better scrolling
      if (window.matchMedia('(hover: none) and (pointer: coarse)').matches) {
        cardEl.removeEventListener('mousemove', mouseMoveHandler as EventListener);
        cardEl.style.transform = 'none';
      }
    });
  }

  getAFreeQuote(): void {
    this.modalService.open(ContactUsComponent, {
      centered: true,
      backdrop: 'static',
      windowClass: 'contact-modal'
    });
  }

  bookAFreeCall(): void {
    this.getAFreeQuote();
  }
}
